import { Affix, Button, Card, Form, Modal, notification, Space, Spin } from "antd";
import { IOU_COST_LIST_ENDPOINT, IOU_DISBURSE_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData, postData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import IOUDisbursementForm from "../IOUDisbursementForm";
import { checkPermission } from "../config/checkPermission";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { alertPop } from "apiServices/common/helper";
import { ROLES } from "../constants/roles";

const UpdateIOUDisbursement = (props) => {
  const { width, viewMode, mode, isEdit } = props;

  const [editInfo, setEditInfo] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { iouCostId } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const loggedInUserId = parseInt(localStorage.getItem("user_id"), 10);
  const loggedInUserRole = localStorage.getItem("user_type");
  const isCreator = loggedInUserId === editInfo?.user?.id;

  const canUpdate = checkPermission(
    loggedInUserRole,
    editInfo?.status,
    isCreator,
    "update",
    editInfo.department_approve,
    editInfo.director_approve,
    editInfo?.account_approve,
  );
  const canView = checkPermission(
    loggedInUserRole,
    editInfo?.status,
    isCreator,
    "view",
    editInfo.department_approve,
    editInfo.director_approve,
    editInfo?.account_approve,
  );

  // Get current user info from Redux store
  const currentUser = useSelector((state) => state.auth?.user);

  const getIOUCostInfo = useCallback(async (id) => {
    setIsLoading(true);
    const query = `${IOU_COST_LIST_ENDPOINT}/${id}`;
    const response = await getData(query);

    if (response && response?.status === 200) {
      const iouCostData = response?.data?.data;
      setEditInfo(iouCostData);
    } else {
      HandleNotification("error", "Error!", response?.message || "Failed to get IOU data");
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (iouCostId) {
      getIOUCostInfo(iouCostId);
    }
  }, [iouCostId, getIOUCostInfo]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/iou-disbursement");
  };

  // const updateIOUCost = () => {
  //   Modal.confirm({
  //     title: "Confirm Disbursement",
  //     content: `Are you sure you want to disburse ?`,
  //     okText: "Yes, Disburse",
  //     cancelText: "Cancel",
  //     onOk: async () => {
  //       try {
  //         setIsLoading(true);

  //         const formData = new FormData();
  //         formData.append("iou_id", iouCostId);

  //         const response = await postData(IOU_DISBURSE_ENDPOINT, formData);

  //         if (
  //           response &&
  //           (response?.code === 200 || response?.status === 200)
  //         ) {
  //           getIOUCostInfo(iouCostId);
  //           alertPop(
  //             "success",
  //             response.message || "IOU Disbursement completed successfully",
  //           );
  //         }
  //       } catch (error) {
  //         notification.error({
  //           message: "Error",
  //           description: "Failed to disburse IOU",
  //           placement: "topRight",
  //         });
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     },
  //   });
  // };

  const updateIOUCost = async () => {
    try {
      // Validate the form fields
      const values = await form.validateFields();

      setIsLoading(true);

      const formData = new FormData();
      formData.append("iou_id", iouCostId);
      formData.append("receive_by", values.receive_by); // Add receive_by to the payload

      const response = await postData(IOU_DISBURSE_ENDPOINT, formData);

      if (response && (response?.code === 200 || response?.status === 200)) {
        getIOUCostInfo(iouCostId);
        alertPop("success", response.message || "IOU Disbursement completed successfully");
        navigate("/import-export-expense-tracking/iou-disbursement");
      }
    } catch (error) {
      if (error.name === "Error") {
        notification.error({
          message: "Validation Error",
          description: "Please fill in all required fields.",
          placement: "topRight",
        });
      } else {
        notification.error({
          message: "Error",
          description: "Failed to disburse IOU",
          placement: "topRight",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const ActionUI = () => {
    return (
      <Space>
        <Button size="small" key={1} danger onClick={() => discardForm()}>
          {viewMode ? "Back" : "Discard"}
        </Button>

        <Button
          size="small"
          key={2}
          type="primary"
          onClick={() => updateIOUCost()}
          hidden={
            editInfo?.disburse_status === "approved" ||
            [ROLES.DEPARTMENT_HEAD, ROLES.DIRECTOR, ROLES.ACCOUNTS].includes(loggedInUserRole)
          }
          disabled={isLoading}
          loading={isLoading}
        >
          Disburse
        </Button>
      </Space>
    );
  };
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
          backgroundColor: "#fff",
        }}
      >
        <Spin spinning={isLoading} />
      </div>
    );
  }

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title={`${viewMode ? "View" : "Edit"} IOU Request`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </Affix>

      {/*canUpdate && !viewMode ? (*/}

      <IOUDisbursementForm
        form={form}
        isEdit={true}
        viewMode={viewMode}
        editInfo={editInfo}
        currentUser={currentUser}
        mode={mode}
        canUpdate={canUpdate}
      />
    </>
  );
};

export default UpdateIOUDisbursement;
